import { useMemo } from 'react';
import create from './createHook.js';
import parseJson from './parseJson.js';
export default (storageArea) => {
    const useStorage = create(storageArea);
    return function useJsonStorage(key, reviver) {
        const value = useStorage(key);
        return useMemo(() => parseJson(value, reviver), [value]);
    };
};
//# sourceMappingURL=createJsonHook.js.map